import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	description: {
		'& .MuiOutlinedInput-root': {
			borderRadius: '12px',
		},
	},
}));
